import { tv } from '@ui/tv';

export type CreatePageLayout = 'split' | 'stacked';

export const createPageVariants = tv({
  slots: {
    body: '',
    intro: 'flex',
    header: 'flex',
    aside: 'flex empty:hidden',
    content: 'min-w-0',
  },
  variants: {
    layout: {
      // intro 2/5, form 3/5 — the form is the wider column on the design
      split: {
        body: 'grid grid-cols-1 gap-8 lg:grid-cols-5',
        intro: 'flex-col gap-6 lg:col-span-2',
        header: 'flex-col gap-4',
        aside: 'flex-col items-start gap-3',
        content: 'lg:col-span-3',
      },
      // one column for narrow hosts such as the settings shell: the intro
      // becomes one row — compact header left, help links stacked right
      stacked: {
        body: 'flex flex-col gap-6',
        intro: 'flex-wrap items-start justify-between gap-x-8 gap-y-4',
        header: 'min-w-0 items-center gap-4',
        aside: 'shrink-0 flex-col items-start gap-1.5',
        content: '',
      },
    },
  },
  defaultVariants: {
    layout: 'split',
  },
});
